<template>
    <ab-flow-base-cmp :movable="true" :block="block" class="ab-test-editor-cmp">

        <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>

        <q-card>

            <q-card-section class="bg-red-8 text-white">
                {{title}}
            </q-card-section>
        </q-card>

        <div class="results">
            <ab-flow-link-connector v-for="(e, k) of outTests" class="q-mt-sm" :block="block" type="output" :event="e.name" :key="k"/>
        </div>

    </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";

export default {
    components: { AbFlowBaseCmp, AbFlowLinkConnector},
    inject: ['canvas'],
    props: ['block'],
    name: "AbTestEditorCmp",
    computed: {

        /**
         * Return name
         * @return {{}}
         */
        title() {
            return this.block.properties?.title || "NoName"
        },

        /**
         * Tests list
         * @return {*|*[]}
         */
        outTests() {
            return this.block.properties && this.block.properties.tests ? this.block.properties.tests : []
        }
    }
}

</script>

<style lang="scss">

.ab-test-editor-cmp {
  .ev-run {
    left:-12px;
    position: absolute;
    top:calc(50% - 5px);
  }

  .results {
    position: absolute;
    right: -12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

</style>
